// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"11dd65d9","692":"10b2ee08"}[chunkId] + ".chunk.js";
};